<template>
<div class ="tips" >
  <div class="weui-msg box">
        <div class="weui_loading">
            <i class="weui-loading weui-icon_toast"></i>
        </div>
        <p class="weui-toast_content">数据加载中</p>
  </div>
	<div class="tpis-mask"></div>
	</div>
</template>

<script>
export default {
	name: 'Tips',
  	data () {
	    return {
	    }
	}   
}
</script>


<style>
@import url('../../common/css/style.css');
@import url('../../common/css/weui.css');
.tips{
  text-align:center;
}
.tips .box{
  position: fixed;
  z-index: 101;
  width:70%;
  top:30%;
  left:15%;
  font-size:16px;
  color:#fff;
}

.tips .tpis-mask{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 100;
	background: rgba(7,17,27,0.6);
}


</style>


// WEBPACK FOOTER //
// src/components/tips/MachineAlive.vue